module.exports = __webpack_public_path__ + "static/media/docs-real.2cf57429.png";